export default {
	root: {
		fontFamily: 'FustatSemiBold',
		fontSize: 16,
		lineHeight: 1.2,
		color: '#302E2A',
	},
}
